<template>
  <div id="about" class="module">
    <h1>About</h1>

    <el-card v-if="Company" class="box-card">
      <el-row :gutter="80">
        <el-col :span="17" class="flexbox">
          <h2>{{ Company.name }}</h2>

          <div>
            <p>{{ Company.company_bio }}</p>
          </div>

          <h4>{{ $attrs.footnote }}</h4>
        </el-col>

        <el-col :span="7">
          <contact-block type="website" :link="Company.website" />
          <contact-block type="address" :value="Company.location" />
          <contact-block type="phone number" :link="Company.phone_number" />
        </el-col>

        <!-- <ApolloQuery
            :query="require('@/graphql/Company/About.gql')"
            :variables="{ name: companyName }"
            :update="data => packageData(data)"
        >
            <template slot-scope="{ result: { loading, data } }">
                <div v-if="loading">
                    Loading ...
                </div>

                <div v-else-if="data">
                    <el-col :span="17" class="flexbox">
                        <h2>{{ Company.name }}</h2>

                        <div>{{ Company.company_bio }}</div>

                        <h4>{{ $attrs.footnote }}</h4>
                    </el-col>

                    <el-col :span="7">
                        <contact-block type="website" :link="Company.website"/>
                    </el-col>
                </div>
            </template>
        </ApolloQuery> -->
      </el-row>
    </el-card>
  </div>
</template>

<script>
// import gql from "graphql-tag";
import ApolloCompanyAbout from "@/graphql/Company/About.gql";

export default {
  name: "AboutCompany",
  components: {
    ContactBlock: () => import("@/components/ContactBlock.vue")
  },
  /* asyncComputed: {
      Company: {
          async get() {
              return await this.BasicInfo[0].Company[0];
          }
      }
  }, */
  apollo: {
    Company: {
      query: ApolloCompanyAbout,
      variables() {
        return { companyName: this.$store.state.company.name };
      },
      update(data) {
        const Company = data.Company[0];
        Company.location =
          `${Company.address_1}<br>` +
          (Company.address_2 ? `${Company.address_2}<br>` : "") +
          `${Company.city}, ${Company.state} ${Company.zip_code}`;
        return Company;
      }
    }
  }
};
</script>

<style lang="scss">
h2 {
  margin-bottom: 2rem;
}

h4 {
  margin-top: 3.5rem;
}

.el-col {
  flex-direction: column;
}

div.contact-block {
  &:not(:last-child) {
    margin-bottom: 3.5rem;
  }

  span.type {
    font-weight: 700;
    font-size: 14px;
    color: rgba(66, 66, 66, 0.59);
    letter-spacing: 1px;
    line-height: 17px;
    text-transform: uppercase;
  }

  span.value {
    font-weight: 400;
    font-size: 16px;
    color: #8a8a8a;
    letter-spacing: 0;
    line-height: 23px;
  }

  span.link, a.link {
    font-weight: 400;
    font-size: 16px;
    color: #2bd8b6;
    letter-spacing: 0;
    line-height: 23px;
    overflow-wrap: break-word;
  }
}
</style>
